import { TableProps, Tooltip } from "antd";
import { AdType, FillAdInfoTableData } from "../shared/types";
import { fillAdInfoColumns } from "./constants";
import { FillAdInfoColumnTitle } from "../shared/types";
import styles from "./AdLibrary.module.scss";
import EditableCell from "screens/assetExporter/feedConfiguration/EditableCell";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { columnTitleTooltipContent, hasRowError } from "./utils/columnsUtils";

const renderColumnTitle = (columnTitle: FillAdInfoColumnTitle) => {
  const tooltipContent = columnTitleTooltipContent[columnTitle];
  return (
    <div className={styles.mediaColumnTitleWrapper}>
      <span className={styles.mediaColumnTitle}>{columnTitle}</span>
      {tooltipContent && (
        <Tooltip trigger="hover" title={tooltipContent}>
          <QuestionCircleOutlined className={styles.mediaColumnIcon} />
        </Tooltip>
      )}
    </div>
  );
};

const renderMediaColumn = (columnTitle: FillAdInfoColumnTitle) => {
  const MediaColumn = (_: any, rowData: FillAdInfoTableData) => (
    <div className={styles.fillAdInfoThumbnailWrapper}>
      <img className={styles.thumbnail} src={rowData[columnTitle] ?? ""} />
    </div>
  );
  MediaColumn.displayName = `MediaColumn(${columnTitle})`;
  return MediaColumn;
};

const renderEditableColumn = (
  columnTitle: FillAdInfoColumnTitle,
  onSave: (value: string) => void,
  onApplyToAll: (value: string) => void,
) => {
  const EditableColumn = (
    _: any,
    rowData: FillAdInfoTableData,
    index: number,
  ) => (
    <EditableCell
      value={rowData[columnTitle] ?? ""}
      onSave={newValue => onSave(newValue.toString())}
      onApplyToAll={() => onApplyToAll(rowData[columnTitle] ?? "")}
      index={columnTitle}
      rowIdentifier={index.toString()}
      placeholderText="Click to add"
    />
  );
  EditableColumn.displayName = `EditableColumn(${columnTitle})`;
  return EditableColumn;
};

export const getColumns = (
  adType: AdType | null,
  onSave: (value: string) => void,
  onApplyToAll: (value: string) => void,
): TableProps<FillAdInfoTableData>["columns"] => {
  if (!adType) return [];

  return fillAdInfoColumns[adType].map(columnTitle => {
    const isMediaColumn =
      columnTitle === FillAdInfoColumnTitle.InFeedMedia ||
      columnTitle === FillAdInfoColumnTitle.StoryMedia;

    const columnRenderer = isMediaColumn
      ? renderMediaColumn(columnTitle)
      : renderEditableColumn(columnTitle, onSave, onApplyToAll);

    return {
      title: renderColumnTitle(columnTitle),
      dataIndex: columnTitle,
      className: styles.fillAdInfoColumn,
      fixed: isMediaColumn || columnTitle === FillAdInfoColumnTitle.AdName,
      render: columnRenderer,
      onCell: (rowData: FillAdInfoTableData) => ({
        className: hasRowError(rowData, columnTitle)
          ? styles.invalidCellContent
          : "",
      }),
    };
  });
};
